(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["age-verification-modal"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('age-verification-modal');
  const yesButton = document.getElementById('yes-button');
  const noButton = document.getElementById('no-button');

  // Check if the age verification cookie exists
  if (!getCookie('ageVerified')) {
    modal.style.display = 'flex';
  }

  yesButton.addEventListener('click', function () {
    setCookie('ageVerified', 'true', 30);
    modal.style.display = 'none';
  });

  noButton.addEventListener('click', function () {
    alert('You must be 18 years or older to enter this site.');
    window.location.href = 'https://www.google.com';
  });

  function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + d.toUTCString();
    document.cookie = name + '=' + value + ';' + expires + ';path=/';
  }

  function getCookie(name) {
    const cname = name + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(cname) == 0) {
        return c.substring(cname.length, c.length);
      }
    }
    return '';
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skw-blankers-product"]) return;
  try {
    

const accordionBtns = document.querySelectorAll(".bk-accordion");

accordionBtns.forEach((accordion) => {
  accordion.onclick = function () {
    this.classList.toggle("is-open");

    let content = this.nextElementSibling;
    console.log(content);

    if (content.style.maxHeight) {
      //this is if the accordion is open
      content.style.maxHeight = null;
    } else {
      //if the accordion is currently closed
      content.style.maxHeight = content.scrollHeight + "px";
      console.log(content.style.maxHeight);
    }
  };
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skw-blankers"] && !Shopify.designMode) return;
  try {
    
gsap.registerPlugin(ScrollTrigger)

gsap.from('.skxbk-right-content', {
  x: 100,
    opacity: 0,
    stagger: .25,
    scrollTrigger: {
        trigger: '.skxbk',
        start: 'top center',
        end: 'bottom 40%',
    }
})

// gsap.from('.skxbk-header', {
//     y: 100,
//     opacity: 0,
//     delay: .15,
//     scrollTrigger: {
//         trigger: '.skxbk',
//         start: 'top center',
//         end: 'bottom 40%',
//     }
// })
// gsap.from('.skxbk-desc', {
//     y: 100,
//     opacity: 0,
//     delay: .25,
//     scrollTrigger: {
//         trigger: '.skxbk',
//         start: 'top center',
//         end: 'bottom 40%',
//     }
// })
// gsap.from('#blk-doodle-btn', {
//     y: 100,
//     opacity: 0,
//     scrollTrigger: {
//         trigger: '.skxbk',
//         start: 'top center',
//         end: 'bottom 40%',
//     }
// })
gsap.from('.skxbk-left img', {
    x: -100,
    opacity: 0,
    stagger: .25,
    scrollTrigger: {
        trigger: '.skxbk',
        start: 'top center',
        end: 'bottom 40%',
    }
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skw-faq"]) return;
  try {
    
  const items = document.querySelectorAll('.faq-accordion button');

  function toggleAccordion() {
    const itemToggle = this.getAttribute('aria-expanded');
  
    for (i = 0; i < items.length; i++) {
      items[i].setAttribute('aria-expanded', 'false');
    }
  
    if (itemToggle == 'false') {
      this.setAttribute('aria-expanded', 'true');
    }
  }
  
  items.forEach((item) => item.addEventListener('click', toggleAccordion));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skw-ijoy-product"]) return;
  try {
    

const accordionBtns = document.querySelectorAll(".bk-accordion");

accordionBtns.forEach((accordion) => {
  accordion.onclick = function () {
    this.classList.toggle("is-open");

    let content = this.nextElementSibling;
    console.log(content);

    if (content.style.maxHeight) {
      //this is if the accordion is open
      content.style.maxHeight = null;
    } else {
      //if the accordion is currently closed
      content.style.maxHeight = content.scrollHeight + "px";
      console.log(content.style.maxHeight);
    }
  };
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skw-mobile-nav"] && !Shopify.designMode) return;
  try {
    
  
const accordion = document.querySelector('.accordion');

accordion.addEventListener('click', (e) => {
  const activePanel = e.target.closest('.accordion-panel');
  toggleAccordion(activePanel);
});

function toggleAccordion(panelToActivate) {
  const activeButton = panelToActivate.querySelector('button');
  const activePanel = panelToActivate.querySelector('.accordion-content');
  const activePanelIsOpened = activeButton.getAttribute('aria-expanded');

  if (activePanelIsOpened === 'true') {
    panelToActivate
      .querySelector('button')
      .setAttribute('aria-expanded', false);

    panelToActivate
      .querySelector('.accordion-content')
      .setAttribute('aria-hidden', true);
  } else {
    panelToActivate.querySelector('button').setAttribute('aria-expanded', true);

    panelToActivate
      .querySelector('.accordion-content')
      .setAttribute('aria-hidden', false);
  }
}

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skw-our-products"] && !Shopify.designMode) return;
  try {
    
  const ourProducts = gsap.utils.toArray('.our-products-item')
  
  gsap.from('.our-products-itemlist', {
      y: 100,
      opacity: 0,
      duration: 1, 
      stagger: .15,
      scrollTrigger: {
        trigger: '.our-products-container',
        start: 'top 60%',
      }
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skw-our-vision"] && !Shopify.designMode) return;
  try {
    
  gsap.from('.vision-left', {
    x: -100,
    opacity: 0,
    scrollTrigger: {
      trigger: '.vision-container',
      start: 'top 60%',
    }
  })
  gsap.from('.vision-right', {
    x: 100,
    opacity: 0,
    scrollTrigger: {
      trigger: '.vision-container',
      start: 'top 60%',
    }
  })

  } catch(e) { console.error(e); }
})();
})();
